import React from "react";

const ManageOrders = () => {
  return (
    <div>
      <h2 className="mt-4 text-center">Order Management is coming soon!</h2>
    </div>
  );
};

export default ManageOrders;
